import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

export const GoLink = styled(Link)`
  align-items: center;
  background: #1e1f20;
  border-radius: 4px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  justify-content: center;
  line-height: 24px;
  margin-top: 24px;
  padding: 12px 0;
  text-decoration: none;
  width: 100%;
`;
